import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import Table from "react-bootstrap/esm/Table";
import "./AuctionInformationSection.css";
import loanApplicationUtility from "utilities/LoanApplicationUtility";
import { isValid } from "date-fns";
interface AuctionInformationSectionProps {
  loanDetails: LoanApplication;
}

export default class AuctionInformationSection extends React.Component<AuctionInformationSectionProps> {
  render() {
    return (
      <>
        {this.props.loanDetails.loanAuctionInformation !== undefined &&
          (<>
            <div>
              <h3>Auction Information</h3>
              <Table bordered striped={false} size="sm">
                <tbody>
                  <>
                    <tr>
                      <td width="250px" className="app-info"><strong>Lot ID#</strong></td>
                      <td className="app-info">{this.props.loanDetails.loanAuctionInformation.lotId}</td>
                    </tr>
                    <tr>
                      <td width="250px" className="app-info"><strong>Auction End Date</strong></td>
                      <td className="app-info">{isValid(this.props.loanDetails.loanAuctionInformation.auctionEndDate) ? loanApplicationUtility.GetFullYearDateText(this.props.loanDetails.loanAuctionInformation.auctionEndDate ?? new Date()) : new Date(this.props.loanDetails.loanAuctionInformation.auctionEndDate ?? new Date()).toLocaleDateString()}</td>
                    </tr>
                    <tr>
                      <td width="250px" className="app-info"><strong>Listing URL</strong></td>
                      <td className="app-info">{this.props.loanDetails.loanAuctionInformation.listingUrl}</td>
                    </tr>
                    {(this.props.loanDetails.loanAuctionInformation.natureOfBusiness ?? '').length > 0 &&
                      <tr>
                        <td width="250px" className="app-info"><strong>What Is The Nature Of Your Business?</strong></td>
                        <td className="app-info">{this.props.loanDetails.loanAuctionInformation.natureOfBusiness}</td>
                      </tr>
                    }
                    {(this.props.loanDetails.loanAuctionInformation.products ?? '').length > 0 &&
                      <tr>
                        <td width="250px" className="app-info"><strong>What Products Do You Sell?</strong></td>
                        <td className="app-info">{this.props.loanDetails.loanAuctionInformation.products}</td>
                      </tr>
                    }
                    {(this.props.loanDetails.loanAuctionInformation.services ?? '').length > 0 &&
                      <tr>
                        <td width="250px" className="app-info"><strong>What Services Do You Provide?</strong></td>
                        <td className="app-info">{this.props.loanDetails.loanAuctionInformation.services}</td>
                      </tr>
                    }
                    {(this.props.loanDetails.loanAuctionInformation.geoAreas ?? '').length > 0 &&
                      <tr>
                        <td width="250px" className="app-info"><strong>What Geographical Area(s) Do You Serve?</strong></td>
                        <td className="app-info">{this.props.loanDetails.loanAuctionInformation.geoAreas}</td>
                      </tr>
                    }
                  </>
                </tbody>
              </Table>
            </div>
          </>)
        }
      </>
    );
  }
}